<template>
  <div
    class="assistant-answer tw:whitespace-normal tw:[&_ol]:list-decimal tw:[&_ol]:pl-5 tw:[&_ul]:list-disc tw:[&_ul]:pl-5 tw:[&>*+*]:mt-2"
  >
    <!-- eslint-disable vue/no-v-html -- The complete answer is sanitized at this display boundary. -->
    <div v-html="html" />
    <!-- eslint-enable vue/no-v-html -->
    <Carousel v-if="images.length" class="tw:mt-2.5 tw:w-full tw:max-w-65">
      <CarouselContent>
        <CarouselItem v-for="image in images" :key="image.url">
          <Button
            variant="ghost"
            class="tw:block tw:w-full tw:p-0 tw:overflow-hidden tw:rounded-(--radius-note) tw:border tw:border-border tw:bg-card"
            :aria-label="t('nkf.assistant.viewImage')"
            @click="$emit('view-image', image.url)"
          >
            <img
              :src="image.url"
              :alt="t('nkf.assistant.imagePreview')"
              loading="lazy"
              class="tw:h-32 tw:w-full tw:object-contain"
              @error="failedImages.add(image.url)"
            />
          </Button>
        </CarouselItem>
      </CarouselContent>
      <template v-if="images.length > 1">
        <CarouselPrevious class="tw:left-1 tw:top-1/2 tw:-translate-y-1/2" />
        <CarouselNext class="tw:right-1 tw:top-1/2 tw:-translate-y-1/2" />
      </template>
    </Carousel>
  </div>
</template>
<script setup>
// 1. Import necessary components
import { computed, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import TextUtils from '@/shared/utilities/text-utils';
import { Button } from './ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from './ui/carousel';
// 2. Use
const props = defineProps({ message: { type: Object, required: true } });
defineEmits(['view-image']);
const { t } = useI18n();
// 3. Define a reactive variable
const failedImages = reactive(new Set());
// 4. Define methods or computed properties if needed
const html = computed(() =>
  TextUtils.sanitizeHtml(props.message.html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: [],
    ALLOW_ARIA_ATTR: false,
    ALLOW_DATA_ATTR: false,
  }),
);
// The API selects illustrations for the answer but provides no step-to-image mapping.
// Keep every selected image in one gallery rather than guessing its clinical instruction.
const images = computed(() => props.message.images.filter((image) => !failedImages.has(image.url)));
// 5. VueJS Hooks
</script>
